import { Tag } from "antd";
import { useEffect } from "react";
 
const Tags = ({ 
  chartOptionsForecasts, 
  setChartOptions, 
  setCompareChartOptions, 
  setLinePositions, 
  linePositions, 
  ref44, 
  setNewForecastLineTimestamp,
  compareChartOptions
}) => {  
  useEffect(() => {
    if (linePositions.length === 0) {
      setNewForecastLineTimestamp(null);
    }
  }, [linePositions]);

  const handleDeleteForecast = (chartOptionsForecast) => {
    const currentForecastTimestamp = chartOptionsForecast.timestamp;
 
    setLinePositions((prevLinePositions) => prevLinePositions?.filter(linePosition => linePosition.date !== currentForecastTimestamp));

    setChartOptions((prevOptions) => {
      return {
        ...prevOptions,
        series: prevOptions.series?.filter(series => series.name !== chartOptionsForecast.name),
        xAxis: {
          ...prevOptions.xAxis,
          plotLines: prevOptions.xAxis.plotLines?.filter((plotLine) => {
            return plotLine.value !== currentForecastTimestamp;
          }),
        }
      };
    });
    if (compareChartOptions){
      setCompareChartOptions((prevOptions) => {
        return {
          ...prevOptions,
          series: prevOptions?.series?.filter(series => series.name !== chartOptionsForecast.name),
          xAxis: {
            ...prevOptions?.xAxis,
            plotLines: prevOptions?.xAxis?.plotLines?.filter((plotLine) => {
              return plotLine.value !== currentForecastTimestamp;
            }),
          }
        };
      });
    }
  };
 
  const renderTagsChartsForecasts = () => {
    return (
      chartOptionsForecasts?.map((chartOptionsForecast) => {
        const color = linePositions.find(linePosition => linePosition.date === chartOptionsForecast.timestamp).color;
        return (
          <Tag key={chartOptionsForecast.name} closable onClose={() => handleDeleteForecast(chartOptionsForecast)} color={color}>
            {chartOptionsForecast.name}
          </Tag>
        )
      })
    );
  };
 
  return (
    <div ref={ref44}>
      {renderTagsChartsForecasts()}
    </div>
  );
};
 
export default Tags;